import { Streamfield, WagtailImage } from '@/types';
import Hero from '@components/Hero';
import Streamfields from '@streamfields/Streamfields';
import { BasePageProps, basePageWrap } from '@views/BasePage';
import React from 'react';

type Props = {
  banner_image: WagtailImage;
  content: Streamfield[] | null;
} & BasePageProps;

function KursTypPage(props: Props) {
  const { banner_image: bannerImage, content } = props;

  return (
    <div className='kurstyp-page'>
      <Hero title={props.title} image={bannerImage} />
      {content ? <Streamfields fields={content} /> : null}
    </div>
  );
}

export default basePageWrap(KursTypPage);
